if not App.angularApp?
    return

# sync scrollTop with another element on the page
App.angularApp.directive 'mfSyncScrollTop', =>
    return {
        restrict: 'A'
        link: ($scope, element, attrs) =>
            other = $(attrs.mfSyncScrollTop)
            other.on 'scroll', (e) =>
                $(element).scrollTop other.scrollTop()
    }
